/* eslint-disable */
import * as THREE from '../../../libs/three.js/build/three.module.js';
import {
  sphereGeometry,
  sphereMaterialHovered,
  getCurrentlyHovered,
  setCurrentlyHovered,
  getCurrentlyFocused,
  isHovering,
  getCourseLocal, setCourseLocal,
  getPitchLocal, setPitchLocal,
  getRollLocal, setRollLocal,
  getPosXLocal, setPosXLocal,
  getPosYLocal, setPosYLocal,
  getPosZLocal, setPosZLocal,
  getImage360Accepted,
  isInImage360Accepted,
} from './constants.js';

/**
 * Mixin z metodami UI dla Images360
 * Zawiera logikę tworzenia i zarządzania elementami interfejsu
 */
export const Images360UIMixin = (Base) => class extends Base {
  
  /**
   * Tworzy przycisk na dole ekranu
   */
  createBottomButton(value, bottom) {
    let button = document.createElement('input');
    button.value = value;
    button.style.bottom = bottom;
    button.style.right = '10px'; // Always position from right edge of viewport
    button.style.left = 'auto'; // Override any left positioning
    button.type = 'button';
    button.classList.add('my-button');
    return button;
  }

  /**
   * Tworzy przycisk na górze ekranu
   */
  createTopButton(value, top) {
    let button = document.createElement('input');
    button.value = value;
    button.style.top = top;
    button.type = 'button';
    button.classList.add('my-button');
    return button;
  }

  /**
   * Tworzy suwak
   */
  createSlider(top, step, min, max, value) {
    let slider = document.createElement('input');
    slider.type = 'range';
    slider.step = step;
    slider.min = min;
    slider.max = max;
    slider.value = value;
    slider.style.top = top;
    slider.classList.add('my-slider');
    return slider;
  }

  /**
   * Tworzy pole numeryczne
   */
  createInput(top) {
    let input = document.createElement('input');
    input.type = 'number';
    input.value = 0;
    input.style.top = top;
    input.style.right = '140px'; // Position closer to right edge
    input.classList.add('my-input');
    return input;
  }

  /**
   * Inicjalizuje popup z listą panoram
   */
  initPopup(viewer, changeFOV) {
    let popup = document.createElement('div');
    popup.addEventListener('mouseover', () => {
      const renderArea = document.getElementById('potree_render_area');
      if (renderArea) renderArea.removeEventListener('wheel', changeFOV);
    });
    popup.addEventListener('mouseleave', () => {
      const renderArea = document.getElementById('potree_render_area');
      if (renderArea) renderArea.addEventListener('wheel', changeFOV);
    });
    popup.classList.add('my-popup');
    
    let header = document.createElement('header');
    header.classList.add('my-popup-header');
    let span = document.createElement('span');
    span.classList.add('my-popup-span');
    popup.id = 'popup';
    popup.appendChild(header);
    popup.appendChild(span);

    this.domRoot = viewer.renderer.domElement.parentElement;
    this.domRoot.appendChild(popup);
    popup.style.display = 'none';
    this.popup = popup;

    return { popup, header };
  }

  /**
   * Inicjalizuje przyciski podstawowe (unfocus, bigger, smaller)
   */
  initBasicButtons(viewer) {
    // Unfocus button — new UI style
    let elUnfocus = document.createElement('button');
    elUnfocus.type = 'button';
    elUnfocus.title = 'Exit panorama';
    elUnfocus.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    elUnfocus.style.cssText = 'display:none;position:fixed;bottom:16px;right:16px;z-index:10001;'
      + 'width:40px;height:40px;border-radius:50%;border:1px solid var(--card-border,#444);'
      + 'background:var(--sidebar-bg,#1e1e1e);color:var(--sidebar-text,#eee);'
      + 'cursor:pointer;padding:0;'
      + 'box-shadow:0 2px 8px rgba(0,0,0,0.3);'
      + 'transition:background 0.15s,border-color 0.15s,transform 0.1s;'
      + 'display:none;align-items:center;justify-content:center;';
    elUnfocus.addEventListener('mouseenter', () => {
      elUnfocus.style.background = 'var(--sidebar-hover,#333)';
      elUnfocus.style.borderColor = 'var(--brand-primary,#0097b2)';
      elUnfocus.style.transform = 'scale(1.08)';
    });
    elUnfocus.addEventListener('mouseleave', () => {
      elUnfocus.style.background = 'var(--sidebar-bg,#1e1e1e)';
      elUnfocus.style.borderColor = 'var(--card-border,#444)';
      elUnfocus.style.transform = 'scale(1)';
    });
    elUnfocus.addEventListener('click', () => this.unfocus());
    this.elUnfocus = elUnfocus;
    this.domRoot.appendChild(elUnfocus);

    // Slide out of the way when a right-side panel covers the canvas edge.
    const applyPanelOffset = (width) => {
      elUnfocus.style.right = `${16 + (width || 0)}px`;
    };
    applyPanelOffset(
      parseInt(
        getComputedStyle(document.documentElement).getPropertyValue('--potree-right-panel-offset'),
        10
      ) || 0
    );
    window.addEventListener('potree-panel-width-changed', (e) => {
      applyPanelOffset(e.detail?.width ?? 0);
    });

    // Bigger button
    let elBigger = this.createBottomButton('+', '110px');
    elBigger.style.width = '45px';
    elBigger.style.height = '45px';
    elBigger.style.fontSize = '2em';
    elBigger.style.lineHeight = '45px';
    elBigger.style.textAlign = 'center';
    elBigger.style.position = 'fixed'; // Use fixed positioning to always be relative to viewport
    elBigger.style.zIndex = '10001'; // Ensure it's above other elements
    elBigger.style.display = 'none'; // Shown only while a panorama is focused
    if (this.isMobile) {
      elBigger.classList.add('mobile-tool-btn');
      elBigger.style.borderRadius = '50%';
      elBigger.style.color = 'white';
    }
    elBigger.addEventListener('click', () => {
      if (this.currentRadius <= 2) {
        this.currentRadius *= 1.1;
        sphereGeometry.scale(1.1, 1.1, 1.1);
      }
    });
    this.elBigger = elBigger;
    this.domRoot.appendChild(elBigger);

    // Smaller button
    let elSmaller = this.createBottomButton('-', '60px');
    elSmaller.style.width = '45px';
    elSmaller.style.height = '45px';
    elSmaller.style.fontSize = '2em';
    elSmaller.style.lineHeight = '45px';
    elSmaller.style.textAlign = 'center';
    elSmaller.style.position = 'fixed'; // Use fixed positioning to always be relative to viewport
    elSmaller.style.zIndex = '10001'; // Ensure it's above other elements
    elSmaller.style.display = 'none'; // Shown only while a panorama is focused
    if (this.isMobile) {
      elSmaller.classList.add('mobile-tool-btn');
      elSmaller.style.borderRadius = '50%';
      elSmaller.style.color = 'white';
    }
    elSmaller.addEventListener('click', () => {
      if (this.currentRadius >= 0.03) {
        this.currentRadius *= 0.9;
        sphereGeometry.scale(0.9, 0.9, 0.9);
      }
    });
    this.elSmaller = elSmaller;
    this.domRoot.appendChild(elSmaller);
  }

  /**
   * Inicjalizuje przyciski edycji (export, save, delete, undo) - tylko desktop
   */
  initEditButtons(viewer) {
    if (this.isMobile) {
      this.elExport = null;
      this.saveBtn = null;
      this.deleteBtn = null;
      this.undoBtn = null;
      return;
    }

    // Export button (shown when not focused, replaced by X when focused)
    let elExport = this.createBottomButton('', '10px');
    elExport.type = 'image';
    elExport.src = Potree.resourcePath + '/icons/export.png';
    elExport.style.backgroundColor = '#fafafa';
    elExport.style.width = '45px';
    elExport.style.height = '45px';
    elExport.style.fontWeight = '0.2em';
    elExport.style.objectFit = 'contain';
    elExport.style.padding = '8px';
    elExport.style.boxSizing = 'border-box';
    elExport.style.position = 'fixed'; // Use fixed positioning to always be relative to viewport
    elExport.style.zIndex = '10001'; // Ensure it's above other elements
    elExport.style.display = 'none'; // Shown only in edit mode when no panorama is focused
    elExport.addEventListener('click', () => this.exportAccepted());
    this.elExport = elExport;
    this.domRoot.appendChild(elExport);

    // Save button - moved below position controls to avoid overlap
    let saveBtn = this.createTopButton('save', '420px');
    saveBtn.style.display = 'none'; // Hidden by default, shown when edit mode is on and hovering
    saveBtn.addEventListener('click', () => {
      this.acceptRotation();
    });
    this.saveBtn = saveBtn;
    this.domRoot.appendChild(saveBtn);

    // Delete button - moved below position controls to avoid overlap
    let deleteBtn = this.createTopButton('delete', '465px');
    deleteBtn.style.display = 'none'; // Hidden by default, shown when edit mode is on and hovering
    deleteBtn.addEventListener('click', () => {
      this.deleteView();
      this.showHoveringEdit();
    });
    this.deleteBtn = deleteBtn;
    this.domRoot.appendChild(deleteBtn);

    // Undo button
    let undoBtn = this.createTopButton('undo delete', '220px');
    undoBtn.style.display = 'none';
    undoBtn.addEventListener('click', () => {
      this.undoDelete();
      this.showHoveringEdit();
    });
    this.undoBtn = undoBtn;
    this.domRoot.appendChild(undoBtn);
  }

  /**
   * Inicjalizuje kontrolki rotacji i pozycji - tylko desktop
   */
  initEditControls(viewer) {
    if (this.isMobile) {
      this.rotationHeader = null;
      this.axisXPosRot = null;
      this.xInput = null;
      this.axisYPosRot = null;
      this.yInput = null;
      this.axisZPosRot = null;
      this.zInput = null;
      this.positionHeader = null;
      this.axisXPos = null;
      this.xPosInput = null;
      this.axisYPos = null;
      this.yPosInput = null;
      this.axisZPos = null;
      this.zPosInput = null;
      return;
    }

    // Rotation header
    let rotationHeader = document.createElement('div');
    this.rotationHeader = rotationHeader;
    rotationHeader.innerText = 'Rotation';
    rotationHeader.id = 'images360-rotation-header'; // Add ID for easier debugging
    Object.assign(rotationHeader.style, {
      position: 'absolute',
      top: '60px',
      right: '20px',
      color: '#FFFFFF',
      fontWeight: '600',
      backgroundColor: 'rgba(0, 151, 178, 0.9)',
      padding: '6px 12px',
      borderRadius: '8px',
      fontSize: '14px',
      zIndex: 10000,
      display: 'none', // Hidden by default, shown when edit mode is on and hovering
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
    });
    this.domRoot.appendChild(rotationHeader);

    // X rotation (roll) - moved down to avoid compass
    this.initRotationControl('X', '100px', 'roll');
    
    // Y rotation (pitch)
    this.initRotationControl('Y', '140px', 'pitch');
    
    // Z rotation (course)
    this.initRotationControl('Z', '180px', 'course');

    // Position header
    let positionHeader = document.createElement('div');
    this.positionHeader = positionHeader;
    positionHeader.innerText = 'Position';
    positionHeader.id = 'images360-position-header'; // Add ID for easier debugging
    Object.assign(positionHeader.style, {
      position: 'absolute',
      top: '240px',
      right: '20px',
      color: '#FFFFFF',
      fontWeight: '600',
      backgroundColor: 'rgba(0, 151, 178, 0.9)',
      padding: '6px 12px',
      borderRadius: '8px',
      fontSize: '14px',
      zIndex: 10000,
      display: 'none', // Hidden by default, shown when edit mode is on and hovering
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
    });
    this.domRoot.appendChild(positionHeader);

    // Position controls - moved down
    this.initPositionControl('X', '280px');
    this.initPositionControl('Y', '320px');
    this.initPositionControl('Z', '360px');
  }

  /**
   * Inicjalizuje pojedynczą kontrolkę rotacji
   */
  initRotationControl(axis, top, type) {
    const slider = this.createSlider(top, 0.1, -180.0, 180.0, 0);
    const input = this.createInput(top);
    
    // Hide controls by default, shown when edit mode is on and hovering
    slider.style.display = 'none';
    input.style.display = 'none';

    const updateRotation = (value) => {
      if (!isHovering()) return;
      
      let val = parseFloat(value) * 1.0;
      if (val > 180) val = 180.0;
      else if (val < -180) val = -180.0;
      else if (isNaN(val)) val = 0;

      if (type === 'roll') setRollLocal(val);
      else if (type === 'pitch') setPitchLocal(val);
      else if (type === 'course') setCourseLocal(val);

      slider.value = val;
      input.value = val;

      if (this.focusedImage) {
        const { course, pitch, roll } = this.focusedImage;
        this.sphere.rotation.set(
          THREE.MathUtils.degToRad(+roll + 90 + getRollLocal()),
          THREE.MathUtils.degToRad(-pitch + getPitchLocal()),
          THREE.MathUtils.degToRad(-course + 90 + getCourseLocal()),
          'ZYX'
        );
      }
    };

    input.addEventListener('input', () => updateRotation(input.value));
    slider.addEventListener('input', () => updateRotation(slider.value));

    this.domRoot.appendChild(slider);
    this.domRoot.appendChild(input);

    if (axis === 'X') {
      this.axisXPosRot = slider;
      this.xInput = input;
    } else if (axis === 'Y') {
      this.axisYPosRot = slider;
      this.yInput = input;
    } else if (axis === 'Z') {
      this.axisZPosRot = slider;
      this.zInput = input;
    }
  }

  /**
   * Inicjalizuje pojedynczą kontrolkę pozycji
   */
  initPositionControl(axis, top) {
    const slider = this.createSlider(top, 0.1, -100.0, 100.0, 0);
    const input = this.createInput(top);
    
    // Hide controls by default, shown when edit mode is on and hovering
    slider.style.display = 'none';
    input.style.display = 'none';

    const updatePosition = (value) => {
      if (!isHovering()) return;
      
      const val = parseFloat(value) || 0;

      if (axis === 'X') setPosXLocal(val);
      else if (axis === 'Y') setPosYLocal(val);
      else if (axis === 'Z') setPosZLocal(val);

      slider.value = val;
      input.value = val;
      this.updateSpherePosition();
    };

    input.addEventListener('input', () => updatePosition(input.value));
    slider.addEventListener('input', () => updatePosition(slider.value));

    this.domRoot.appendChild(slider);
    this.domRoot.appendChild(input);

    if (axis === 'X') {
      this.axisXPos = slider;
      this.xPosInput = input;
    } else if (axis === 'Y') {
      this.axisYPos = slider;
      this.yPosInput = input;
    } else if (axis === 'Z') {
      this.axisZPos = slider;
      this.zPosInput = input;
    }
  }

  /**
   * Inicjalizuje obsługę przeciągania popupu
   */
  initPopupDragging(popup, header) {
    let isDragging = false;
    let offsetX, offsetY;

    header.scope = this;
    header.addEventListener('mousedown', (e) => {
      isDragging = true;
      // Fix: Calculate offset consistently - always use the actual popup position
      const popupRect = popup.getBoundingClientRect();
      offsetX = e.clientX - popupRect.left;
      offsetY = e.clientY - popupRect.top;
    });

    document.addEventListener('mousemove', (e) => {
      if (isDragging) {
        // Calculate position relative to viewport (clientX/Y are viewport-relative)
        let newX = e.clientX - offsetX;
        let newY = e.clientY - offsetY;
        
        // Get the popup's parent container position to adjust if needed
        const popupParent = popup.offsetParent;
        if (popupParent) {
          const parentRect = popupParent.getBoundingClientRect();
          // Adjust if parent has offset
          newX = newX - parentRect.left;
          newY = newY - parentRect.top;
        }
        
        // Constrain to viewport bounds
        const popupWidth = popup.offsetWidth || 350;
        const popupHeight = popup.offsetHeight || 350;
        const maxX = (popupParent ? popupParent.offsetWidth : window.innerWidth) - popupWidth;
        const maxY = (popupParent ? popupParent.offsetHeight : window.innerHeight) - popupHeight;
        
        if (newX >= 0 && newX <= maxX) {
          popup.style.left = newX + 'px';
        }
        if (newY >= 0 && newY <= maxY) {
          popup.style.top = newY + 'px';
        }
      }
    });

    document.addEventListener('mouseup', () => {
      isDragging = false;
    });
  }

  /**
   * Updates UI element positioning based on sidebar visibility
   * When sidebar is visible, render area is shifted 300px right, so we need to adjust UI positioning
   */
  updateUIPositionForSidebar() {
    const renderArea = document.getElementById('potree_render_area');
    if (!renderArea) return;
    
    // Check if sidebar is visible by checking render area's left position
    const computedStyle = window.getComputedStyle(renderArea);
    const leftValue = computedStyle.left;
    const sidebarVisible = leftValue !== '0px' && leftValue !== '';
    const sidebarOffset = sidebarVisible ? 300 : 0;
    
    // Base positions (when sidebar is hidden) - closer to right edge
    const basePositions = {
      rotationHeader: 20,
      positionHeader: 20,
      slider: 20,
      input: 140,
      button: 20
    };
    
    // Update rotation header
    if (this.rotationHeader) {
      this.rotationHeader.style.right = (basePositions.rotationHeader + sidebarOffset) + 'px';
    }
    
    // Update position header
    if (this.positionHeader) {
      this.positionHeader.style.right = (basePositions.positionHeader + sidebarOffset) + 'px';
    }
    
    // Update all rotation controls (sliders and inputs)
    const rotationControls = [
      { slider: this.axisXPosRot, input: this.xInput },
      { slider: this.axisYPosRot, input: this.yInput },
      { slider: this.axisZPosRot, input: this.zInput }
    ];
    
    rotationControls.forEach(({ slider, input }) => {
      if (slider) {
        slider.style.right = (basePositions.slider + sidebarOffset) + 'px';
      }
      if (input) {
        input.style.right = (basePositions.input + sidebarOffset) + 'px';
      }
    });
    
    // Update all position controls (sliders and inputs)
    const positionControls = [
      { slider: this.axisXPos, input: this.xPosInput },
      { slider: this.axisYPos, input: this.yPosInput },
      { slider: this.axisZPos, input: this.zPosInput }
    ];
    
    positionControls.forEach(({ slider, input }) => {
      if (slider) {
        slider.style.right = (basePositions.slider + sidebarOffset) + 'px';
      }
      if (input) {
        input.style.right = (basePositions.input + sidebarOffset) + 'px';
      }
    });
    
    // Update save and delete buttons
    if (this.saveBtn) {
      this.saveBtn.style.right = (basePositions.button + sidebarOffset) + 'px';
    }
    if (this.deleteBtn) {
      this.deleteBtn.style.right = (basePositions.button + sidebarOffset) + 'px';
    }
    if (this.undoBtn) {
      this.undoBtn.style.right = (basePositions.button + sidebarOffset) + 'px';
    }
  }

  /**
   * Zarządza wyświetlaniem kontrolek w zależności od trybu edycji
   */
  displayControls(isEditOn) {
    const isEditModeOn = this.getEditModeChecked();
    const currentlyHovered = getCurrentlyHovered();
    const hovering = isHovering();
    const image360Accepted = getImage360Accepted();

    for (let image of this.images) {
      if ((!isEditModeOn && image.isHidden) || image.mesh === currentlyHovered) {
        image.mesh.visible = false;
        this.dispatchEvent({ type: 'hidden-image', image: image });
      } else if (isEditModeOn && image.isHidden) {
        image.mesh.material = new THREE.MeshBasicMaterial({
          side: THREE.FrontSide,
          color: 0x002299,
        });
        image.mesh.visible = this.panoramaAllowedByActiveClip(image);
        this.dispatchEvent({ type: 'unhide-image', image: image });
      }
    }

    // Update UI positioning for sidebar visibility
    this.updateUIPositionForSidebar();

    // Check if a panorama is focused (not just hovering)
    const isFocused = !!this.focusedImage;

    // Sphere size is now controlled via the Appearance panel slider
    if (this.elBigger) this.elBigger.style.display = 'none';
    if (this.elSmaller) this.elSmaller.style.display = 'none';

    // Unfocus (X) shown only when focused
    this.elUnfocus.style.display = isFocused ? 'flex' : 'none';

    // Old floating export button — disabled, export is now in the sidebar panel
    if (this.elExport) {
      this.elExport.style.display = 'none';
    }

    // Old floating popup — disabled, the sidebar panel replaces it
    if (this.popup != null) {
      this.popup.style.display = 'none';
    }

    // Old floating rotation/position controls — disabled, now in sidebar panel
    this.hideHoveringEdit();
  }

  /**
   * Buduje listę panoram w popupie
   */
  buildPopupList() {
    const hovering = isHovering();
    
    let list = document.createElement('ul');
    // Append to the span element (scrollable area), not directly to popup
    const popupSpan = this.popup.querySelector('.my-popup-span');
    if (popupSpan) {
      popupSpan.appendChild(list);
    } else {
      this.popup.append(list);
    }
    list.style.top = '0px';
    list.style.marginTop = '0px';
    list.style.paddingTop = '0px';

    // First pass: collect all button texts to find the longest
    const buttonTexts = [];
    for (let image of this.images) {
      let text = String(image.file);
      if (text.lastIndexOf('./') === -1) {
        text = text.slice(text.lastIndexOf('/'), text.length);
      } else {
        text = text.split('./').pop();
      }
      buttonTexts.push(text);
    }
    
    // Find the longest text to set uniform button width
    const longestText = buttonTexts.reduce((a, b) => a.length > b.length ? a : b, '');
    const maxButtonWidth = Math.max(120, longestText.length * 8 + 24); // Calculate width based on text length

    for (let image of this.images) {
      let newListElement = document.createElement('li');
      newListElement.id = 'li-' + image.file;
      newListElement.setAttribute('href', '#' + image.file);

      let newListButton = document.createElement('input');
      newListButton.id = image.file;
      if (isInImage360Accepted(image)) {
        newListButton.classList.add('saved');
      }

      let text = String(image.file);
      if (text.lastIndexOf('./') === -1) {
        text = text.slice(text.lastIndexOf('/'), text.length);
      } else {
        text = text.split('./').pop();
      }

      newListButton.type = 'button';
      newListButton.value = text;
      newListButton.style.width = maxButtonWidth + 'px'; // Set uniform width
      newListButton.targetView = image;
      newListButton.scope = this;

      newListButton.addEventListener('mouseover', function (event) {
        event.currentTarget.targetView.mesh.material = sphereMaterialHovered;
      });

      newListButton.addEventListener('mouseleave', function (event) {
        event.currentTarget.scope.handleSavedArr();
      });

      newListButton.addEventListener('click', function (event) {
        event.currentTarget.scope.focusList(event.currentTarget.targetView);
      });

      let newCheckbox = document.createElement('input');
      newCheckbox.type = 'checkbox';
      newCheckbox.classList.add('popup-input-checkbox');
      newCheckbox.checked = image.isHidden;
      newCheckbox.targetView = image;
      newCheckbox.scope = this;
      newCheckbox.addEventListener('change', function (event) {
        if (this.checked) {
          event.currentTarget.targetView.isHidden = true;
          event.currentTarget.scope.dispatchEvent({
            type: 'hidden-image',
            image: event.currentTarget.targetView,
          });
          event.currentTarget.scope.handleSavedArr();
          if (isHovering()) {
            event.currentTarget.scope.showHoveringEdit();
          }
        } else {
          event.currentTarget.targetView.isHidden = false;
          event.currentTarget.scope.dispatchEvent({
            type: 'unhide-image',
            image: event.currentTarget.targetView,
          });
          event.currentTarget.scope.handleSavedArr();
          if (isHovering()) {
            event.currentTarget.scope.showHoveringEdit();
          }
        }
      });

      let newTextField = document.createElement('div');
      let newText = document.createTextNode(image.name);
      newTextField.appendChild(newText);
      newListElement.appendChild(newListButton);
      newListElement.appendChild(newCheckbox);
      newListElement.appendChild(newTextField);
      newListElement.style.zIndex = 10010;
      list.appendChild(newListElement);
    }
  }

  /**
   * Ukrywa kontrolki edycji podczas hovera
   */
  hideHoveringEdit() {
    if (this.isMobile) return;

    if (this.xInput) this.xInput.style.display = 'none';
    if (this.yInput) this.yInput.style.display = 'none';
    if (this.zInput) this.zInput.style.display = 'none';
    if (this.axisXPosRot) this.axisXPosRot.style.display = 'none';
    if (this.axisYPosRot) this.axisYPosRot.style.display = 'none';
    if (this.axisZPosRot) this.axisZPosRot.style.display = 'none';
    if (this.saveBtn) this.saveBtn.style.display = 'none';
    if (this.deleteBtn) this.deleteBtn.style.display = 'none';
    if (this.undoBtn) this.undoBtn.style.display = 'none';
    if (this.xPosInput) this.xPosInput.style.display = 'none';
    if (this.yPosInput) this.yPosInput.style.display = 'none';
    if (this.zPosInput) this.zPosInput.style.display = 'none';
    if (this.axisXPos) this.axisXPos.style.display = 'none';
    if (this.axisYPos) this.axisYPos.style.display = 'none';
    if (this.axisZPos) this.axisZPos.style.display = 'none';
    if (this.positionHeader) this.positionHeader.style.display = 'none';
    if (this.rotationHeader) this.rotationHeader.style.display = 'none';
  }

  /**
   * Pokazuje kontrolki edycji podczas hovera
   */
  showHoveringEdit() {
    if (this.isMobile) {
      return;
    }

    const currentlyFocused = getCurrentlyFocused();
    
    // Check 1: Verify controls exist
    const controlsExist = {
      xInput: !!this.xInput,
      yInput: !!this.yInput,
      zInput: !!this.zInput,
      axisXPosRot: !!this.axisXPosRot,
      axisYPosRot: !!this.axisYPosRot,
      axisZPosRot: !!this.axisZPosRot,
      saveBtn: !!this.saveBtn,
      xPosInput: !!this.xPosInput,
      yPosInput: !!this.yPosInput,
      zPosInput: !!this.zPosInput,
      axisXPos: !!this.axisXPos,
      axisYPos: !!this.axisYPos,
      axisZPos: !!this.axisZPos,
      positionHeader: !!this.positionHeader,
      rotationHeader: !!this.rotationHeader
    };
    
    // Check 2: Verify domRoot and container positioning
    if (this.domRoot) {
      const computedStyle = window.getComputedStyle(this.domRoot);
    } else {
      console.error('[Images360] domRoot is null!');
    }

    // Show rotation controls - use inline-block for inputs to ensure visibility
    const displayResults = {};
    if (this.xInput) {
      this.xInput.style.display = 'inline-block';
      displayResults.xInput = 'set to inline-block';
    } else {
      displayResults.xInput = 'NOT FOUND';
    }
    
    if (this.yInput) this.yInput.style.display = 'inline-block';
    if (this.zInput) this.zInput.style.display = 'inline-block';
    if (this.axisXPosRot) this.axisXPosRot.style.display = 'inline-block';
    if (this.axisYPosRot) this.axisYPosRot.style.display = 'inline-block';
    if (this.axisZPosRot) this.axisZPosRot.style.display = 'inline-block';
    if (this.saveBtn) this.saveBtn.style.display = 'inline-block';
    if (this.xPosInput) this.xPosInput.style.display = 'inline-block';
    if (this.yPosInput) this.yPosInput.style.display = 'inline-block';
    if (this.zPosInput) this.zPosInput.style.display = 'inline-block';
    if (this.axisXPos) this.axisXPos.style.display = 'inline-block';
    if (this.axisYPos) this.axisYPos.style.display = 'inline-block';
    if (this.axisZPos) this.axisZPos.style.display = 'inline-block';
    
    if (this.positionHeader) {
      this.positionHeader.style.display = 'block';
    }
    
    if (this.rotationHeader) {
      this.rotationHeader.style.display = 'block';
    }
    
    // Final check: Verify all visible elements are actually in viewport
    const allControls = [
      { name: 'rotationHeader', el: this.rotationHeader },
      { name: 'positionHeader', el: this.positionHeader },
      { name: 'xInput', el: this.xInput },
      { name: 'yInput', el: this.yInput },
      { name: 'zInput', el: this.zInput },
      { name: 'axisXPosRot', el: this.axisXPosRot },
      { name: 'axisYPosRot', el: this.axisYPosRot },
      { name: 'axisZPosRot', el: this.axisZPosRot },
      { name: 'saveBtn', el: this.saveBtn },
      { name: 'xPosInput', el: this.xPosInput },
      { name: 'yPosInput', el: this.yPosInput },
      { name: 'zPosInput', el: this.zPosInput },
      { name: 'axisXPos', el: this.axisXPos },
      { name: 'axisYPos', el: this.axisYPos },
      { name: 'axisZPos', el: this.axisZPos }
    ];
    
    const visibilityReport = allControls.map(control => {
      if (!control.el) return { name: control.name, exists: false };
      const rect = control.el.getBoundingClientRect();
      const computed = window.getComputedStyle(control.el);
      return {
        name: control.name,
        exists: true,
        inDOM: document.body.contains(control.el),
        display: computed.display,
        visibility: computed.visibility,
        opacity: computed.opacity,
        position: computed.position,
        right: computed.right,
        top: computed.top,
        rect: {
          width: rect.width,
          height: rect.height,
          top: rect.top,
          right: rect.right,
          left: rect.left,
          bottom: rect.bottom
        },
        inViewport: rect.width > 0 && rect.height > 0 && 
                   rect.top >= 0 && rect.left >= 0 && 
                   rect.right <= window.innerWidth && 
                   rect.bottom <= window.innerHeight,
        potentiallyVisible: computed.display !== 'none' && 
                            computed.visibility !== 'hidden' && 
                            parseFloat(computed.opacity) > 0
      };
    });

    if (currentlyFocused != null) {
      if (currentlyFocused.toDelete) {
        if (this.deleteBtn) this.deleteBtn.style.display = 'none';
        if (this.undoBtn) this.undoBtn.style.display = '';
      } else {
        if (this.deleteBtn) this.deleteBtn.style.display = '';
        if (this.undoBtn) this.undoBtn.style.display = 'none';
      }
    }
  }

  getEditModeChecked() {
    return this._editMode || false;
  }

  setEditMode(value) {
    this._editMode = !!value;
    this.displayControls(this._editMode);
  }

  getRenderDistance() {
    return this._renderDistance ?? 150;
  }

  setRenderDistance(value) {
    this._renderDistance = value;
    if (isHovering()) this.renderSpheres();
  }

  setSphereSize(value) {
    const targetRadius = value;
    if (targetRadius <= 0 || targetRadius > 2) return;
    const scale = targetRadius / this.currentRadius;
    this.currentRadius = targetRadius;
    sphereGeometry.scale(scale, scale, scale);
  }
};

